import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Spinner from '@/components/Spinner'
import { fetchTableOfContents } from '@/reducers/asset/asyncActions'
import { isRequestingTableOfContentsSelector } from '@/selectors'

import PanelContent from './PanelContent'

const TableOfContentsPanel = () => {
  const path = useSelector(
    state => state.asset.productDetails.tableOfContentsPath
  )
  const isRequestAllowed = useSelector(isRequestingTableOfContentsSelector)

  const isLoading = useSelector(
    state => state.asset.tableOfContents.isLoading
  )
  const error = useSelector(
    state => state.asset.tableOfContents.error
  )

  const dispatch = useDispatch()

  useEffect(() => {
    if (isRequestAllowed) dispatch(fetchTableOfContents({ path }))
  }, [path])

  return (
    <Choose>
      <When condition={isLoading}>
        <Spinner />
      </When>
      <When condition={error}>
        {error}
      </When>
      <Otherwise>
        <PanelContent />
      </Otherwise>
    </Choose>
  )
}

export default TableOfContentsPanel
